<template>
  <el-container style="height: 100vh;">
    <el-aside width="200px" style="background-color: #2e3440;">
      <el-menu
        default-active="1"
        class="el-menu-vertical-demo"
        background-color="#2e3440"
        text-color="#fff"
      >
        <el-menu-item index="1" @click="$router.push('/home/userList')">
          <i class="el-icon-user"></i>
          <span>用户管理</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header style="text-align: right; font-size: 14px">
        <span>欢迎：{{ username }}</span>
        <el-button text type="text" @click="logout">退出登录</el-button>
      </el-header>

      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { useUserStore } from '@/store/user'

export default {
  data() {
    return {
      username: ''
    }
  },

  mounted() {
    const userStore = useUserStore()
    this.username = userStore.username
  },

  methods: {
    logout() {
      const userStore = useUserStore()
      userStore.clearUser()
      this.$message.success('已退出')
      this.$router.push('/login')
    }
  }
}
</script>

<style>
.el-header {
  background: #fff;
  line-height: 60px;
  padding-right: 20px;
}
</style>